import { Avatar, Box, Button, Card, Chip, Typography } from "@mui/material";
import { createRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import UserAvatar from "../assets/img/1.jpg";
import { IPost } from "../interfaces/IPost";
type IPostCard = {
  data: IPost;
};
const PostCard: React.FC<IPostCard> = ({ data }) => {
  const params = useLocation();
  const myPost = params.pathname === "/my-stories";
  const linkRef = createRef<HTMLAnchorElement>();
  useEffect(() => {
    if (!data.follow) {
      linkRef?.current?.setAttribute("rel", "nofollow");
    }
  }, [data]);
  
  return (
    <Card className="w-full p-1 mt-4 overflow-hidden">
      <Box className="pr-2 pl-2 pt-2 rounded-sm">
        <Box>
          <Link to={`/story/${data.slug}`}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 700 }}
              color="primary"
            >
              {data.title}
            </Typography>
            <Typography variant="body2" color="primary">
              {data.category.name}
            </Typography>
          </Link>
        </Box>
      </Box>
      <Box className="p-2 pb-4">
        <Box className="text-gray-800">{data.description}</Box>
        <Box className="p-0 mt-2">
          <a
            href={data.url}
            ref={linkRef}
            target="_blank"
            className="text-indigo-500"
          >
            {data.url}
          </a>
        </Box>
        <Box className="p-0 mt-2">
          {data.tag.split(",").map((tag) => (
            <Chip
              key={tag}
              size="small"
              label={tag}
              variant="outlined"
              color="primary"
              sx={{ mr: 1, fontSize: 11 }}
            />
          ))}
        </Box>
      </Box>
      {myPost && (
        <Box className="p-2 pb-4">
          <strong>Story Status: </strong> {data.status}
        </Box>
      )}
      <Box className="p-2">
        <Box className="flex justify-between items-center">
          <Box className="flex">
            <Avatar alt="Remy Sharp" src={UserAvatar} />
            <Box className="pl-4">
              <p className="text-sm text-gray-600 font-bold w-36">
                {data.user.name}
              </p>
              <p className="text-xs">{data?.date}</p>
            </Box>
          </Box>
          <Box className="pr-2">
            {/* {myPost && (
              <Button  sx={{mr:2}} variant="outlined" color="error" size="small">
                Delete
              </Button>
            )} */}
            {data.status == "Approved" && (
              <Link to={`/story/${data.slug}`}>
                <Button variant="outlined" size="small">
                  Read More
                </Button>
              </Link>
            )}
          </Box>
        </Box>
      </Box>
    </Card>
  );
};

export default PostCard;
